import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Allroutes from "./routes/AppRouter";
import Sidebar from "./component/sideBar/Sidebar";
import "devextreme/dist/css/dx.light.css";
import "devexpress-gantt/dist/dx-gantt.min.css";
import Header from "./component/header/Header";
import RightSidebar from "./pages/rightSidebar/RightSidebar";
import { Dialog, DialogContent, Drawer, Slide } from "@mui/material";
import NotificationSidebar from "./pages/notification/NotificationSidebar";
import ProfileSidebar from "./pages/profile/ProfileSidebar";
import { TransitionProps } from "@mui/material/transitions";
import Logout from "./pages/logout/Logout";
import { ToastContainer } from 'react-toastify';
import { forwardRef } from "react";
import { motion } from "framer-motion";
import Company from "./pages/company/Company";
import { CantineSidebar } from "./pages/structure/Cantine/CantineSidebar";
import { CantineTerreniSlider } from "./pages/structure/Cantine/CantineTerreniSlider";
import { CantineStabilimentiSlider } from "./pages/structure/Cantine/CantineStabilimentiSlider";
import { CantineProdottiSlider } from "./pages/structure/Cantine/CantineProdottiSlider";
import { CantineMezziSlider } from "./pages/structure/Cantine/CantineMezziSlider";
import { TerreniSlider } from "./pages/structure/Terreni/TerreniSlider";
import { TerreniParticelleSlider } from "./pages/structure/Terreni/TerreniParticelleSlider";
import { TerreniSensoriSlider } from "./pages/structure/Terreni/TerreniSensoriSlider";
import { TerreniTrattamentiSlider } from "./pages/structure/Terreni/TerreniTrattamentiSlider";
import { StabilimentiAttrezzatureSlider } from "./pages/structure/Stabilimenti/StabilimentiAttrezzatureSlider";
import { StabilimentiGiacenzeSlider } from "./pages/structure/Stabilimenti/StabilimentiGiacenzeSlider";
import CompanyProduction from "./pages/Produzione/produzioni/CompanyProduction";
import { TrasportoSlider } from "./pages/Logistica/Trasporto/TrasportoSlider";
import { ManutenzioneSlider } from "./pages/Logistica/Mezzi/ManutenzioneSlider";
import { DocumentiSlider } from "./pages/Logistica/Mezzi/DocumentiSlider";
import { ViaggiSlider } from "./pages/Logistica/Mezzi/ViaggiSlider";
import { MezziSlider } from "./pages/Logistica/Mezzi/MezziSlider";
import { OperatoriSlider } from "./pages/structure/Operatori/OperatoriSlider";
import {StabilimentiSlider} from "./pages/structure/Stabilimenti/StabilimentiSlider"
import { ProdottiSlider } from "./pages/structure/Prodotti/ProdottiSlider";
import { ProductionTrattamentiSlider } from "./pages/Produzione/trattamenti/ProductionTrattamentiSlider";
const Transition = forwardRef((props, ref) => (
  <Slide direction="down" ref={ref} {...props} />
));

const App = () => {
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState(false);
  const [profile, setProfile] = useState(false);
  const [logout, setLogout] = useState(false);
  const [company, setCompany] = useState(false)
  const [cantine, setCantine] = useState((false))
  const [production, setProduction] = useState(false)
  const location = useLocation();
  const toggleDrawer = () => {
    setOpen(false);
    setNotification(false);
    setProfile(false);
    setCompany(false)
    setCantine(false)

  };
  const isOpenTrattamenti = localStorage.getItem("open")
  const isOpenParticelle = localStorage.getItem("particelle")
  const isOpenTrattamentiTerni = localStorage.getItem("trattamenti")
  const isOpenAttrezzature = localStorage.getItem("attrezzature")
  const isOpenManutenzione = localStorage.getItem("manutenzione")
  const isOpenAttrezzatureLogistic = localStorage.getItem("logisticAttrezzature")
  const isOpenGiacenze = localStorage.getItem("structureGiacenze");
  const isOpenGiacenzeProdotti = localStorage.getItem("prodottiGiacenze")
  const isOpenDocumenti = localStorage.getItem("documentiLogistica");
  const isOpenOperatori = localStorage.getItem("strucutreOperatori");
  const isOpenViaggi = localStorage.getItem("viaggiLogistica");
  const isOpenproduction = localStorage.getItem("production");
  useEffect(() => {
    if (isOpenTrattamenti) {
      setCantine(!cantine)
    }

  }, [isOpenTrattamenti])
  useEffect(() => {
    if (isOpenproduction) {
      setCantine(!cantine)
    }

  }, [isOpenproduction])
  useEffect(() => {
    if (isOpenParticelle) {
      setCantine(!cantine)
    }

  }, [isOpenParticelle])
  useEffect(() => {
    if (isOpenAttrezzature) {
      setCantine(!cantine)
    }

  }, [isOpenAttrezzature])
  useEffect(() => {
    if (isOpenAttrezzature) {
      setCantine(!cantine)
    }

  }, [isOpenAttrezzature])
  useEffect(() => {
    if (isOpenTrattamentiTerni) {
      setCantine(!cantine)
    }

  }, [isOpenTrattamentiTerni])
  useEffect(() => {
    if (isOpenAttrezzatureLogistic) {
      setCantine(!cantine)
    }

  }, [isOpenAttrezzatureLogistic])
  useEffect(() => {
    if (isOpenGiacenze) {
      setCantine(true);
    }
  }, [isOpenGiacenze]);

  useEffect(() => {
    if (isOpenGiacenzeProdotti) {
      setCantine(true)
    }
  }, [isOpenGiacenzeProdotti])
  useEffect(() => {
    if (isOpenDocumenti) {
      setCantine(true)
    }
  }, [isOpenDocumenti])
  useEffect(() => {
    if (isOpenOperatori) {
      setCantine(true)
    }
  }, [isOpenOperatori])
  useEffect(() => {
    if (isOpenManutenzione) {
      setCantine(true)
    }
  }, [isOpenManutenzione])
  useEffect(() => {
    if (isOpenViaggi) {
      setCantine(true)
    }
  }, [isOpenViaggi])

  return (
    <div>
      <ToastContainer />
      {![
        "/",
        "/password-success",
        "/verification",
        "/mail-verification",
        "/password-reset",
        "/forgot-password",
      ].includes(location.pathname) && <Sidebar />}

      <div
        className={
          ![
            "/",
            "/password-success",
            "/verification",
            "/mail-verification",
            "/password-reset",
            "/forgot-password",
          ].includes(location.pathname)
            ? "DashboardContainer"
            : ""
        }
      >
        <div
          className={
            ![
              "/",
              "/password-success",
              "/verification",
              "/mail-verification",
              "/password-reset",
              "/forgot-password",
            ].includes(location.pathname)
              ? "DashboardInner"
              : "welcomeDeshboard"
          }
        >
          {![
            "/",
            "/password-success",
            "/verification",
            "/mail-verification",
            "/password-reset",
            "/forgot-password",
          ].includes(location.pathname) && (
              <Header
                open={open}
                notification={notification}
                setNotification={setNotification}
                setOpen={setOpen}
                setProfile={setProfile}
                profile={profile}
                setLogout={setLogout}
                logout={logout}
                company={company}
                setCompany={setCompany}
                cantine={cantine}
                setCantine={setCantine}
                production={production}
                setProduction={setProduction}
              />
            )}
          <Dialog
            open={company}
            onClose={() => setCompany(false)}
            TransitionComponent={Transition}
            className="companyDropDwon"
            sx={{
              "& .MuiDialog-container": {
                alignItems: "flex-start",
                justifyContent: "flex-start",
              },
              "& .MuiPaper-root": {
                marginLeft: "130px",
                marginTop: "75px",
                maxWidth: "300px",
              },
            }}
          >
            <Company onClose={() => setCompany(false)} />
          </Dialog>

          <Drawer
            className="rightSidebarDrawer"
            anchor="right"
            open={open}
            onClose={toggleDrawer}
            transitionDuration={700}
          >
            <RightSidebar />
          </Drawer>

          <Drawer
            sx={{ "& .MuiDrawer-paper": { borderRadius: "10px 0 0 10px" } }}
            anchor="right"
            transitionDuration={700}
            open={notification}
            onClose={() => setNotification(false)}
          >
            <NotificationSidebar />
          </Drawer>
          <Drawer
            sx={{ "& .MuiDrawer-paper": { borderRadius: "10px 0 0 10px" } }}
            anchor="right"
            transitionDuration={700}
            open={profile}
            onClose={() => setProfile(false)}
          >
            <ProfileSidebar />
          </Drawer>
          <Dialog
            className="logOutContainer"
            open={logout}
            onClose={() => setLogout(false)}
            TransitionComponent={Transition}
          >
            <Logout open={logout} setOpen={setLogout} />
          </Dialog>
          <Drawer
            sx={{ "& .MuiDrawer-paper": { borderRadius: "10px 0 0 10px" } }}
            anchor="right"
            transitionDuration={700}
            open={cantine || isOpenTrattamenti || isOpenGiacenze || isOpenDocumenti || isOpenOperatori || isOpenViaggi || isOpenManutenzione}
            onClose={() => {
              setCantine(false); localStorage.removeItem("open"); localStorage.removeItem("particelle"); localStorage.removeItem("trattamenti"); localStorage.removeItem("viaggiLogistica"); localStorage.removeItem("attrezzature"); localStorage.removeItem("logisticAttrezzature");
              localStorage.removeItem("manutenzione"); localStorage.removeItem("structureGiacenze"); localStorage.removeItem("strucutreOperatori"); localStorage.removeItem("documentiLogistica"); localStorage.removeItem("production");
            }}
            className="customDrawer"
          >
            {location.pathname === "/strutture/cantine" && <CantineSidebar cantine={cantine} setCantine={setCantine} />}
            {location.pathname === "/strutture/cantine/Terreni" && <CantineTerreniSlider cantine={cantine} setCantine={setCantine} />}
            {location.pathname === "/strutture/cantine/Stabilimenti" && <CantineStabilimentiSlider cantine={cantine} setCantine={setCantine} />}
            {location.pathname === "/strutture/cantine/Prodotti" && <CantineProdottiSlider cantine={cantine} setCantine={setCantine} />}
            {location.pathname === "/strutture/cantine/Mezzi" && <CantineMezziSlider cantine={cantine} setCantine={setCantine} />}
            {location.pathname === "/strutture/terreni" && <TerreniSlider cantine={cantine} setCantine={setCantine} />}
            {(location.pathname === "/strutture/terreni/Particelle" || isOpenParticelle) && <TerreniParticelleSlider setCantine={setCantine} cantine={isOpenParticelle} />}
            {location.pathname === "/strutture/terreni/Sensori" && <TerreniSensoriSlider cantine={cantine} setCantine={setCantine} />}
            {(location.pathname === "/strutture/terreni/Trattamenti" || isOpenTrattamentiTerni) && <TerreniTrattamentiSlider setCantine={setCantine} cantine={isOpenTrattamentiTerni} />}
            {location.pathname === "/strutture/stabilimenti" && <StabilimentiSlider cantine={cantine} setCantine={setCantine}/>}
            {(location.pathname === "/strutture/stabiliment/Attrezzature" || isOpenAttrezzature) && <StabilimentiAttrezzatureSlider cantine={isOpenAttrezzature} setCantine={setCantine} />}
            {location.pathname === "/strutture/stabiliment/Sensori" && <TerreniSensoriSlider cantine={cantine} setCantine={setCantine} />}
            {(location.pathname === "/strutture/stabiliment/Giacenze") && <StabilimentiGiacenzeSlider cantine={isOpenGiacenze} setCantine={setCantine} />}
            {location.pathname === "/strutture/prodotti" && <ProdottiSlider cantine={cantine} setCantine={setCantine} />}
            {(location.pathname === "/strutture/prodotti/Giacenze") && <StabilimentiGiacenzeSlider cantine={isOpenGiacenze} setCantine={setCantine} />}
            {location.pathname === "/strutture/sensori" && <TerreniSensoriSlider cantine={cantine} setCantine={setCantine}/>}
            {(location.pathname === "/strutture/operatori" || isOpenOperatori) && <OperatoriSlider cantine={isOpenOperatori} setCantine={setCantine} />}
            {(location.pathname === "/produzione/trattamenti") && <ProductionTrattamentiSlider cantine={isOpenproduction} setCantine={setCantine}/>}
            {location.pathname === "/logistica/stabilimenti" && <StabilimentiSlider cantine={cantine} setCantine={setCantine} />}
            {(location.pathname === "/logistica/stabilimenti/Attrezzature") && <StabilimentiAttrezzatureSlider cantine={isOpenAttrezzatureLogistic} setCantine={setCantine}/>}            
            {(location.pathname === "/logistica/stabilimenti/Sensori")&& <TerreniSensoriSlider cantine={cantine} setCantine={setCantine}/>}
            {/* {(location.pathname === "/logistica/stabilimenti/Giacenze" || isOpenGiacenze) && <StabilimentiGiacenzeSlider cantine={isOpenGiacenze} />} */}
            {(location.pathname === "/logistica/trasporto") && <TrasportoSlider cantine={cantine} setCantine={setCantine} />}
            {location.pathname === "/logistica/mezzi" && <MezziSlider cantine={cantine} setCantine={setCantine} />}
            {(location.pathname === "/logistica/mezzi/Manutenzione" || isOpenManutenzione) && <ManutenzioneSlider cantine={isOpenManutenzione} setCantine={setCantine} />}
            {(location.pathname === "/logistica/mezzi/Documenti" || isOpenDocumenti) && <DocumentiSlider cantine={isOpenDocumenti} setCantine={setCantine} />}
            {location.pathname === "/logistica/mezzi/Sensori" && <TerreniSensoriSlider cantine={cantine} setCantine={setCantine} />}
            {(location.pathname === "/logistica/mezzi/Viaggi" || isOpenViaggi) && <ViaggiSlider cantine={isOpenViaggi}  setCantine={setCantine} />}
            {(location.pathname === "/logistica/stabilimenti/Giacenze") && <StabilimentiGiacenzeSlider cantine={isOpenGiacenze} setCantine={setCantine} />}
          </Drawer>
          <Dialog
            open={production}
            onClose={() => setProduction(false)}
            TransitionComponent={Transition}
            className="companyDropDwon"
            sx={{
              "& .MuiDialog-container": {
                display: "flex",
                alignItems: "center", // Center vertically
                justifyContent: "center", // Center horizontally
              },
              "& .MuiPaper-root": {
                margin: 0, // Remove margin to avoid misalignment
                maxWidth: "378px",
                height: "340px",
                width: "100%", // Optional: Adjust width
              },
            }}
          >
            <CompanyProduction setProduction={setProduction} />
          </Dialog>

          <Allroutes />
        </div>
      </div>
    </div>
  );
};

export default App;